import { Link } from "react-router";

import { useCurrentSession } from "@/components/helpers/custom-hooks/use-current-session";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import {
  Col,
  Container,
  PrimaryAnchorBtn,
  PrimaryLinkBtn,
  Row,
} from "@/components/pieces/bootstrap";
import { NAV_Z_INDEX, PUBLIC_CONTENT_MAX_WIDTH } from "@/css/constants";

import { MobileNav } from "./MobileNav";
import { NavLinks } from "./NavLinks";
import { NavLogo } from "./NavLogo";

interface PublicNavProps {
  ctaLink?: string;
  fullWidth?: boolean;
}

export function PlacementNav({
  ctaLink = "/match",
  fullWidth = false,
}: PublicNavProps) {
  const { currentSessionLink } = useCurrentSession();

  return (
    <div
      className="fixed top-0 left-0 w-full bg-white py-2 shadow-sm"
      style={{ zIndex: NAV_Z_INDEX }}
    >
      <Container
        maxWidth={fullWidth ? "100%" : PUBLIC_CONTENT_MAX_WIDTH}
        px={24}
      >
        <Row>
          <Col width={1}>
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center">
                <NavLogo path="/" />
                <Media greaterThanOrEqual="lg">
                  <NavLinks pill={true} />
                </Media>
              </Flex>
              <Flex>
                {currentSessionLink ? (
                  <Flex alignItems="center">
                    <PrimaryLinkBtn
                      className="ml-8 text-white"
                      to={currentSessionLink}
                    >
                      Go to app
                    </PrimaryLinkBtn>
                  </Flex>
                ) : (
                  <Flex alignItems="center">
                    <Media greaterThanOrEqual="lg">
                      <Link
                        className="mr-2 font-semibold text-blue-700 hover:text-[#3788ee]"
                        to="/login"
                      >
                        Login
                      </Link>
                    </Media>
                    {ctaLink.startsWith("http") ? (
                      <PrimaryAnchorBtn
                        className="ml-8 text-white"
                        href={ctaLink}
                      >
                        Get Started
                      </PrimaryAnchorBtn>
                    ) : (
                      <PrimaryLinkBtn className="ml-8 text-white" to={ctaLink}>
                        Get Started
                      </PrimaryLinkBtn>
                    )}
                  </Flex>
                )}
                <Media lessThan="lg">
                  <Box ml={3}>
                    <MobileNav />
                  </Box>
                </Media>
              </Flex>
            </Flex>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
